import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ManageCollectionsPanelComponent } from './manage-collections-panel.component';
import { ModifyCollectionsPanelModule } from '@go-modules/components/library/modify-collections-panel/modify-collections-panel.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccessibleGridReorderDirective } from '@go-modules/directives/accessible-grid-reorder/accessible-grid-reorder.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		FocusOnFirstInvalidFieldModule,
		DragDropModule,
		AccessibleGridReorderDirective,
		ModifyCollectionsPanelModule
	],
	declarations: [
		ManageCollectionsPanelComponent
	],
	exports: [
		ManageCollectionsPanelComponent
	]
})
export class ManageCollectionsPanelModule {}
